import PortalAppService from "../../../application/platform/portal-app-service";
import { ACTION_TYPES, useAuditsDispatch } from "./audits-context";
import { IListAuditsRequest } from "../../../model/base/request/list-audits-request";

export const useAuditsController = () => {
    const auditsDispatch = useAuditsDispatch();

    async function loadData(request: IListAuditsRequest) {
        try {
            // Limpa os dados antes de carregar novos
            auditsDispatch({
                type: ACTION_TYPES.CLEAR_AUDITS,
            });
            const result = await PortalAppService.requestAudits(request);
            auditsDispatch({
                type: ACTION_TYPES.SET_AUDITS,
                payload: result,
            });
        } catch (error) {
            console.log(error);
        }
    }

    async function loadDetail(id: number) {
        try {
            const result = await PortalAppService.requestAuditDetail(id);
            auditsDispatch({
                type: ACTION_TYPES.SET_AUDIT_DETAIL,
                payload: result,
            });
        } catch (error) {
            console.log(error);
        }
    }

    return {
        loadData,
        loadDetail
    };
};
